// extracted by mini-css-extract-plugin
module.exports = {"pick":"Pick_pick__j6_Ay","icon":"Pick_icon__CWsW4","icon__redesign":"Pick_icon__redesign__wn1fP","appName":"Pick_appName__dqSFv","singleLine":"Pick_singleLine__QvlXy"};